import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
// import {CustomEase} from 'gsap/CustomEase';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      gsap.registerPlugin( ScrollTrigger );
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group
        ` ).each( function( key, val ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 80%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( val ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( val ).hasClass( 'js-fade-group' ) ) {
                  $( val ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( val ).addClass( 'js-animated' );
              },
            },
          } );
        } );
        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load
          ` ).each( function( key, val ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: val,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( val ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( val ).hasClass( 'js-fade-group' ) ) {
                  $( val ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( val ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
